import { render, staticRenderFns } from "./ListProgetti.vue?vue&type=template&id=6281431d&"
import script from "./ListProgetti.vue?vue&type=script&lang=js&"
export * from "./ListProgetti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports